<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateContenidoNodo"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionAssetContentsModalEditName.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <AtomInputPrimary
          v-model="datos.nodo.nombre"
          :inputError="$v.datos.nodo.nombre.$error"
          :label="$t('mEditionAssetContentsModalEditName.inputs.nombre.label')"
          :messageError="messageErrorNombre"
          name="nombre"
          type="text"
          @blur="$v.datos.nodo.nombre.$touch()"
        />
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetContentsModalEditName.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAssetContentsModalEditName',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionAssetContentsModalEditName.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      datos: {
        academia: 0,
        nodo: {
          nombre: '',
          titulo: ''
        }
      }
    }
  },

  validations: {
    datos: {
      nodo: {
        nombre: {
          maxLength: maxLength(255),
          minLength: minLength(5),
          required
        }
      }
    }
  },

  computed: {
    messageErrorNombre () {
      return this.$validation.getValidationMessage('mEditionAssetContentsModalEditName', this.$v.datos.nodo.nombre, 'nombre')
    }
  },

  watch: {
    'datos.nodo.nombre' () {
      this.datos.nodo.titulo = this.datos.nodo.nombre
    }
  },

  created () {
    this.datos.academia = this.$store.getters.getAcademyData.id
    this.datos.nodo.nombre = this.$modal.element.node.nombre
    this.datos.nodo.titulo = this.$modal.element.node.nombre
  },

  methods: {
    updateContenidoNodo () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.update('contenido', 'updateContenidoNodo', this.datos, [this.$modal.element.version.id, this.$modal.element.node.id])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionAssetContentsModalEditName', 'updateContenidoNodo', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAssetContentsModalEditName', 'updateContenidoNodo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
